module.exports = __webpack_public_path__ + "static/media/System_logo.f0c75584.png";